import type { RadarDatum } from "./types";

const getAngle = (index: number, total: number) => (index * 2 * Math.PI) / total - Math.PI / 2;

const getPoint = (cx: number, cy: number, radius: number, angle: number, valueRatio: number) => ({
  x: cx + radius * valueRatio * Math.cos(angle),
  y: cy + radius * valueRatio * Math.sin(angle),
});

export const buildPolygonPoints = (
  data: RadarDatum[],
  cx: number,
  cy: number,
  radius: number,
  maxValue: number
) =>
  data
    .map((d, i) => {
      const angle = getAngle(i, data.length);
      const valueRatio = maxValue > 0 ? Math.min(1, Math.max(0, d.value / maxValue)) : 0;
      const { x, y } = getPoint(cx, cy, radius, angle, valueRatio);
      return `${x},${y}`;
    })
    .join(" ");

export const buildGridPaths = (
  count: number,
  levels: number,
  cx: number,
  cy: number,
  radius: number
) => {
  const paths: string[] = [];

  for (let level = 1; level <= levels; level++) {
    const ratio = level / levels;
    const points = Array.from({ length: count }, (_, i) => {
      const angle = getAngle(i, count);
      const { x, y } = getPoint(cx, cy, radius, angle, ratio);
      return `${x},${y}`;
    }).join(" ");
    paths.push(points);
  }

  return paths;
};

export const buildAxisLines = (count: number, cx: number, cy: number, radius: number) =>
  Array.from({ length: count }, (_, i) => {
    const angle = getAngle(i, count);
    const { x: x2, y: y2 } = getPoint(cx, cy, radius, angle, 1);
    return { x2, y2 };
  });

export const buildDataPointCoordinates = (
  data: RadarDatum[],
  cx: number,
  cy: number,
  radius: number,
  maxValue: number
) =>
  data.map((d, i) => {
    const angle = getAngle(i, data.length);
    const valueRatio = maxValue > 0 ? Math.min(1, Math.max(0, d.value / maxValue)) : 0;
    return getPoint(cx, cy, radius, angle, valueRatio);
  });
